import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const PressureConverterGuidePage = () => <DataDrivenGuidePage slug="guide-pressure-calculator" />;

export default PressureConverterGuidePage;
